import axios from 'axios'
const state = {}
const getters = {}
const mutations = {}

// actions
const actions = {
  async get ({ dispatch, commit, state, rootState }, { api, params, noErr }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token
    const response = await axios.get('/api/' + api, { params: params })
    if (response) { return response.data }
  },
  async post ({ dispatch, commit, state, rootState }, { api, data }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token
    const response = await axios.post('/api/' + api, data, {
      headers: { 'Content-Type': 'application/json' },
      maxContentLength: Infinity,
      maxBodyLength: Infinity
    })
    if (response) { return response.data }
  },
  async put ({ dispatch, commit, state, rootState }, { api, data }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token
    const response = await axios.put('/api/' + api, data)
    if (response) { return response.data }
  },
  async delete ({ dispatch, commit, state, rootState }, { api, params, noErr }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token
    const response = await axios.delete('/api/' + api, { params: params })
    if (response) { return response.data }
  },
  async patch ({ dispatch, commit, state, rootState }, { api, data }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + rootState.auth.token
    const response = await axios.delete('/api/' + api, data)
    if (response) { return response.data }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
